import React from 'react';
import { H2 } from '../../theme';
import { Dialog, DialogContent, DialogContentText, Box } from '@mui/material';
import { ModalProps } from '../../utils/types';
import SelfPayMessage from './SelfPayMessage';
import CloseIcon from './CloseIcon';

const TravelersInsuranceModal = ({ open, handleClose }:ModalProps): JSX.Element => {
    return (
        <Dialog
            maxWidth='lg'
            fullWidth={true}
            open={open}
            onClose={handleClose}
        >
            <DialogContent sx={{ padding: '30px' }}>
                <CloseIcon handleClose={handleClose}/>
                <DialogContentText>
                    <Box>
                        <H2>Traveler's Insurance</H2>
                        <SelfPayMessage/>
                    </Box>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default TravelersInsuranceModal;
